import { Component } from '@angular/core';
import { Hero } from '../../common/hero/hero';

@Component({
  selector: 'app-planning',
  imports: [Hero],
  templateUrl: './planning.html',
  styleUrl: './planning.scss',
})
export class Planning {}
